<template>
    <v-popup
        id="view-popup"
        :style="{ 'font-family': ticker.fontFamily, height: '500px' }"
        :ticker="ticker"
    />
</template>

<script>
import vPopup from "./vPopup.vue";

export default {
    name: "TickerBody",
    components: {
        vPopup,
    },
    props: {
        ticker: Object,
    },
    emits: ["updateIframeView"],
};
</script>
